import styles from './styles.module.css'
export default function MethodologyTool({dict}) {
    const {
        methodology_ces_tool_1,
        methodology_ces_tool_2,
        methodology_ces_tool_3,
        methodology_ces_tool_4,
        methodology_ces_tool_5,
        methodology_ces_tool_6,
        methodology_ces_tool_7,
        methodology_ces_tool_8,
        methodology_ces_tool_9,
        methodology_ces_tool_10,
        methodology_ces_tool_11,
        methodology_ces_tool_12,
        methodology_ces_tool_13,
        methodology_ces_tool_14
    } = dict.discover;
    return (
        <section className={styles.container} data-name="methodology-ces-tool">
            <p dangerouslySetInnerHTML={{__html: methodology_ces_tool_1}}/>
            <p dangerouslySetInnerHTML={{__html: methodology_ces_tool_2}}/>
            <h3 className={styles.title}>{methodology_ces_tool_3}</h3>
            <p className={styles.text_with_title} dangerouslySetInnerHTML={{__html: methodology_ces_tool_4}}/>
            <h3 className={styles.title}>{methodology_ces_tool_5}</h3>
            <p className={styles.text_with_title} dangerouslySetInnerHTML={{__html: methodology_ces_tool_6}}/>
            <h3 className={styles.title}>{methodology_ces_tool_7}</h3>
            <p className={styles.text_with_title} dangerouslySetInnerHTML={{__html: methodology_ces_tool_8}}/>
            <h3 className={styles.title}>{methodology_ces_tool_9}</h3>
            <p className={styles.text_with_title} dangerouslySetInnerHTML={{__html: methodology_ces_tool_10}}/>
            <p className={styles.text_with_title} dangerouslySetInnerHTML={{__html: methodology_ces_tool_11}}/>
            <p className={styles.text_with_title} dangerouslySetInnerHTML={{__html: methodology_ces_tool_12}}/>
            <p className={styles.text_with_title} dangerouslySetInnerHTML={{__html: methodology_ces_tool_13}}/>
            <p className={styles.text_with_title} dangerouslySetInnerHTML={{__html: methodology_ces_tool_14}}/>
        </section>
    );
}
